module.exports = __webpack_public_path__ + "media/images/lb/834-c59b20c3bb7f3fb8e3309cff920a2d6c.svg";